import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useToastNotificationContext } from '../../hooks/global/alert/useToastNotification';
import {
  registerErrorModalCallback,
  registerUnexpectedErrorModalCallback,
} from '../../services/errorModalService';

const ErrorFramework = ({ isCustomer }: Readonly<{ isCustomer?: boolean }>) => {
  const { createErrorToast, createToastNotification } =
    useToastNotificationContext();
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();

  //allows to call error toast notification on axiosInstance for a consistent error on failed requests
  useEffect(() => {
    const newCreateUnexpectedErrorToast = (code: number, message: string) => {
      const prevPage = location.pathname;
      createErrorToast(message, () => {
        navigate(
          `customer/contact/customer-ticket?code=${code}&prev=${prevPage}`,
        );
      });
    };

    const reporterToast = (code: number, message: string) => {
      createToastNotification(`(${code}) ${message}`, 'error');
    };

    const newCreateErrorToast = (message: string) => {
      createToastNotification(message, 'error');
    };

    if (isCustomer) {
      registerUnexpectedErrorModalCallback(newCreateUnexpectedErrorToast);
    } else {
      registerUnexpectedErrorModalCallback(reporterToast);
    }
    registerErrorModalCallback(newCreateErrorToast);

    return () => {};
  }, [
    createErrorToast,
    createToastNotification,
    navigate,
    location,
    intl,
    isCustomer,
  ]);

  return <Outlet />;
};

export default ErrorFramework;
